import { User } from 'CommonScripts/user';
import { RequestService } from './request.service';
import { CacheHelper } from 'CommonScripts/cacheHelper';

export class VisualisationGatewayService {
    public static async getDomesticCatalogue() {
        const key: string = 'visualiser_domestic_catalogue';
        return await this.getCatalogue(`${process.env.VISUALISATION_GATEWAY_API}/Catalogue/marshallsdomestic`, key);
    }

    public static async getCommercialCatalogue() {
        const key: string = 'visualiser_commercial_catalogue';
        return await this.getCatalogue(`${process.env.VISUALISATION_GATEWAY_API}/Catalogue/marshallscommercial`, key);
    }

    public static async getPOSCatalogue(catalogue: string) {
        const key: string = `visualiser_pos_${catalogue}_catalogue`;
        return await this.getCatalogue(`${process.env.VISUALISATION_GATEWAY_API}/Catalogue/${catalogue}`, key);
    }

    public static async getSkuProductQuantities(patternId: number, squareMeterage: number, materialTextureKey: string, jointKey: string) {
        return await RequestService.post(`${process.env.VISUALISATION_GATEWAY_API}/designs/design-products-and-qtys`, {
            designAreas: [{
                ptnId: patternId,
                m2: squareMeterage,
                mtlKey: materialTextureKey,
                jntKey: jointKey
            }],
            isSampleRequest: false,
            sessionId: User.getUserId(),
            source: 'APV'
        });
    }

    public static async postJitarModel(materialTextureKey: string, jointKey: string, maskId: number, patternId: number, jointWidth: number) {
        return await RequestService.post(`${process.env.VISUALISATION_GATEWAY_API}/jitar/model-url`, {
            materialTextureKey,
            jointKey,
            maskId,
            patternId,
            jointWidth,
        });
    }

    public static async postAppInteraction(patternId: number, squareMeterage: number, materialTextureKey: string, jointKey: string) {
        return RequestService.post(`${process.env.VISUALISATION_GATEWAY_API}/designs/app-interaction`, {
            designAreas: [{
                ptnId: patternId,
                m2: squareMeterage,
                mtlKey: materialTextureKey,
                jntKey: jointKey
            }],
            sessionId: User.getUserId(),
            source: 'APV'
        });
    }

    public static async postCommercialDownloadData(data: any) {
        return await RequestService.post(`${process.env.VISUALISATION_GATEWAY_API}/designs/stash-lead`, { 
            ...data, 
            Source: 'APV',
            SessionId: User.getUserId(), 
        });
    }

    public static async postCustomPatternData(data: any) {
        return await RequestService.post(`${process.env.VISUALISATION_GATEWAY_API}/designs/custom-pattern`, { 
            ...data, 
            Source: 'APV',
            SessionId: User.getUserId(), 
        });
    }

    private static async getCatalogue(url: string, cacheKey: string) {
        let catalogueObj: any = CacheHelper.getWithExpiry(cacheKey);
        if (!catalogueObj) {
            catalogueObj = await RequestService.get(url);
            CacheHelper.setWithExpiry(cacheKey, catalogueObj, 24);
        }

        return catalogueObj;
    }   
}